import { render, staticRenderFns } from "./DistribuicaoDetalheModal.vue?vue&type=template&id=70beff28&scoped=true&"
import script from "./DistribuicaoDetalheModal.vue?vue&type=script&lang=js&"
export * from "./DistribuicaoDetalheModal.vue?vue&type=script&lang=js&"
import style0 from "./DistribuicaoDetalheModal.vue?vue&type=style&index=0&id=70beff28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70beff28",
  null
  
)

export default component.exports